import { render, staticRenderFns } from "./mapData.vue?vue&type=template&id=2b966b05&scoped=true"
import script from "./mapData.vue?vue&type=script&lang=js"
export * from "./mapData.vue?vue&type=script&lang=js"
import style0 from "./mapData.vue?vue&type=style&index=0&id=2b966b05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b966b05",
  null
  
)

export default component.exports